<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <h3>
                Editar usuario
            </h3>
        </div>
        <div class="col-sm-12 mt-3">
            <label for="" class="form-label">Nombre</label>
            <input type="text" class="form-control form-control-sm" v-model="nombre">
        </div>
        <div class="col-sm-12 mt-3">
            <label for="" class="form-label">Usuario</label>
            <input type="text" class="form-control form-control-sm" autocomplete="off" v-model="usuario">
        </div>
        <div class="col-sm-6 mt-3">
            <label for="" class="form-label">Contraseña</label>
            <input type="password" class="form-control form-control-sm" v-model="pass">
        </div>
        <div class="col-sm-6 mt-3">
            <label for="" class="form-label">Confirmar contraseña</label>
            <input type="password" class="form-control form-control-sm" v-model="pass2">
        </div>
        <!-- <div class="col-sm-12 mt-3">
            <label for="" class="form-label">Perfil</label>
            <select class="form-control form-control-sm" v-model="rol">
                <option value="">Seleccionar</option>
                <option v-for="(item, index) in roles" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
        </div> -->
        <div class="col-sm-10 mt-4">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="registrar_usuario">Guardar</button>
        </div>
        <div class="col-sm-2 mt-4">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="cerrar_formulario">Volver</button>
        </div>
    </b-row>
</template>

<script>
    import { atexto, minix } from '@/components/functions/alertas';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'CrearUsuario',
        computed: {
            ...mapState(['roles', 'sucursal_seleccionada', 'id_empresa_seleccionada', 'usuario_a_editar'])
        },
        data() {
            return {
                nombre: '',
                usuario: '',
                correo: '',
                pass: '',
                pass2: '',
                rol: 1
            }
        },
        methods: {
            async registrar_usuario() {
                if (this.nombre.trim() === '' || this.usuario.trim() === '') {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                } else {
                    // Validación del nombre de usuario
                    const usuarioRegex = /^[a-z][a-z0-9]{4,}$/;

                    if (!usuarioRegex.test(this.usuario)) {
                        atexto({
                            titulo: 'Incumplimientos', 
                            cuerpo: 'El nombre de usuario debe cumplir con los siguientes requisitos: <br><br>' +
                                '- Mínimo 5 caracteres <br>' +
                                '- No puede contener mayúsculas <br>' +
                                '- No puede iniciar con un número <br>' +
                                '- No puede contener espacios', 
                            icono: 'warning'
                        })
                        return;
                    }

                    if (this.pass.trim() != '' && this.pass2.trim() != '') {
                        if (this.pass.trim() === this.pass2.trim()) {
                            const regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
                            let resultado = regex.test(this.pass.trim());

                            if (resultado) {
                                let f = {
                                    id: this.usuario_a_editar.id,
                                    formulario: {
                                        username: this.usuario.trim().toLocaleLowerCase(),
                                        password: this.pass.trim(),
                                        role: this.rol,
                                        nombre_completo: this.nombre.toUpperCase().trim(),
                                    }
                                }

                                await this.actualizar_usuario(f)
                                await this.obtener_vendedores()
                            } else {
                                atexto({ titulo: 'Error!', cuerpo: 'La contraseña debe contener al menos 8 caracteres, una mayúscula y un carácter especial', icono: 'error' })
                            }
                        } else {
                            minix({ icon: 'error', mensaje: 'Las contraseñas no coinciden', tiempo: 3000 })
                        }
                    } else {
                        let f = {
                            id: this.usuario_a_editar.id,
                            formulario: {
                                username: this.usuario.trim().toLocaleLowerCase(),
                                role: this.rol,
                                nombre_completo: this.nombre.toUpperCase().trim(),
                            }
                        }

                        await this.actualizar_usuario(f)
                        await this.obtener_vendedores()
                    }
                }
            },
            cerrar_formulario() {
                this.$emit('actualizar_modulo')
            },
            ...mapActions(['actualizar_usuario', 'obtener_roles', 'obtener_usuarios', 'obtener_vendedores'])
        },
        mounted() {
            this.obtener_roles()
            this.nombre = this.usuario_a_editar.nombre_completo
            this.usuario = this.usuario_a_editar.username
            // this.rol = this.usuario_a_editar.role.id
        },
    }
</script>

<style></style>